import { BucketEndWarning } from "@/components/buckets/BucketEndWarning";
import type { QueryClient } from "@tanstack/react-query";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import type Keycloak from "keycloak-js";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
  auth?: Keycloak;
}>()({
  component: () => (
    <div className="min-h-screen bg-background text-foreground">
      <BucketEndWarning />
      <Outlet />
    </div>
  ),
});
